import type { ProcessStep } from "../types/content";

export const processSteps: ProcessStep[] = [
  {
    title: "Vous nous contactez",
    description:
      "Par téléphone ou formulaire, décrivez votre besoin. Réponse sous 24 h ouvrées.",
  },
  {
    title: "Visite & diagnostic",
    description:
      "Un technicien se déplace gratuitement pour évaluer l'installation existante.",
  },
  {
    title: "Devis détaillé",
    description:
      "Un chiffrage clair, poste par poste, avec les aides auxquelles vous avez droit.",
  },
  {
    title: "Travaux & suivi",
    description:
      "Chantier propre, délais tenus, mise en service et garantie décennale.",
  },
];
